<!-- キーワードから探す 検索ボタン -->
<template>
  <button
    class="crly-a-common-search-keyword-btn crly-icon"
    @click="clickSearchBtn"
  >
    <label>{{ $t("search.keyword.searchBtn") }}</label>
  </button>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordBtn",
  methods: {
    clickSearchBtn() {
      this.$emit("clickSearchBtn");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/btn.scss";
</style>
